/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { IImageTextEditResourceData } from '@umu/umu-types';

interface IInput {
    resource_imgText_id: string;
    page: number;
    size?: number;
}

export const getImageTextList = fetchDataSync((data: IInput): Promise<IListResponse<IImageTextEditResourceData>> => {
    return fetchData(Api.IMAGE_TEXT_LIST, data).then((res: IListResponse<IImageTextEditResourceData>) => {
        return res;
    });
});

export const getImageTextListAsync = (data: IInput): Promise<IListResponse<IImageTextEditResourceData>> => {
    return fetchData(Api.IMAGE_TEXT_LIST, data).then((res: IListResponse<IImageTextEditResourceData>) => {
        return res;
    });
};
